var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClarityPinnedSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_4644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 19.9998H3.99984V3.99984H13.9998C14.368 3.99984 14.6665 3.70136 14.6665 3.33317C14.6665 2.96498 14.368 2.6665 13.9998 2.6665H3.99984C3.64622 2.6665 3.30708 2.80698 3.05703 3.05703C2.80698 3.30708 2.6665 3.64622 2.6665 3.99984V19.9998C2.6665 20.3535 2.80698 20.6926 3.05703 20.9426C3.30708 21.1927 3.64622 21.3332 3.99984 21.3332H19.9998C20.3535 21.3332 20.6926 21.1927 20.9426 20.9426C21.1927 20.6926 21.3332 20.3535 21.3332 19.9998V9.99984C21.3332 9.63165 21.0347 9.33317 20.6665 9.33317C20.2983 9.33317 19.9998 9.63165 19.9998 9.99984V19.9998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3799 6.22004L17.7132 1.55337C17.5856 1.44415 17.4216 1.38708 17.2538 1.39356C17.086 1.40004 16.9269 1.4696 16.8081 1.58833C16.6894 1.70706 16.6199 1.86622 16.6134 2.034C16.6069 2.20179 16.664 2.36584 16.7732 2.49337L17.6932 3.41337L15.0265 6.08004C13.6932 5.50004 12.1265 6.17337 11.0799 7.20004L10.5998 7.67337L12.9599 10.0334L10.9832 12.01C10.7236 12.2696 10.7236 12.6905 10.9832 12.95C11.2428 13.2096 11.6636 13.2096 11.9232 12.95L13.8999 10.9734L16.2465 13.3334L16.7199 12.8534C17.7465 11.8067 18.4199 10.2467 17.8399 8.9067L20.5065 6.24004L21.4265 7.16004C21.4863 7.22983 21.5598 7.28651 21.6425 7.32652C21.7252 7.36654 21.8153 7.38902 21.9071 7.39257C21.999 7.39612 22.0905 7.38065 22.1761 7.34713C22.2616 7.31361 22.3393 7.26277 22.4043 7.1978C22.4693 7.13283 22.5201 7.05514 22.5536 6.96959C22.5871 6.88404 22.6026 6.79248 22.5991 6.70067C22.5955 6.60886 22.573 6.51877 22.533 6.43606C22.493 6.35335 22.4363 6.2798 22.3665 6.22004H22.3799Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_4644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClarityPinnedSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clarity_pinned-solid.cb1289459e9b1b2368a5020b2ec7c5e5.svg";